import {makeStyles} from '@material-ui/core/styles';
import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';
import {CardActionArea} from '@material-ui/core';
import blogIcon from '../assets/blog.png';
import faqIcon from '../assets/Faq.png';
import videoIcon from '../assets/Video.png';

const useStyles = makeStyles((theme) => ({

  auctionPageTitle: {
    marginTop: '100px',
    marginBottom: '50px',
    fontWeight: 500,
    color: '#F782ED',
    fontSize: '38px',
    fontFamily: 'Gilroy-Medium, sans-serif',
  },
  auctionPageInfo: {
    color: 'white',
    width: '35%',
    letterSpacing: '1px',
    fontSize: '16px',
    marginTop: '20px',
    fontWeight: 500,
    fontFamily: 'Gilroy-Medium, sans-serif',
    margin: '0 auto',
    marginBottom: '24px',
  },
  grid: {
    display: 'flex',
    justifyContent: 'center'
  },

  cardSection: {
    paddingTop: '50px',
    paddingbottom: '50px',
    flexGrow: 1,
    width: '100%',
  },

  card: {
    background: 'linear-gradient(270deg, #3457F2 0%, #B139D8 100%)',
    color: 'white',
    width: '60%',
    maxWidth: '343px',
    margin: '0 auto',
    borderRadius: '20px',
    paddingBottom: '10px',
    position: 'relative',
  },
  media: {
    height: '227px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    background: 'transparent',
    backgroundColor: 'rgba(33, 35, 40, 1)',
    borderRadius: 0,
  },
  img: {
    width: '120px',
    height: '120px',
    backgroundSize: 'contain',
  },

  cardTitle: {
    color: '#F782ED',
    fontWeight: 700,
    fontFamily: 'Gilroy-Medium, sans-serif',
    fontSize: '23px',
  },
  firstImage: {
    position: 'absolute',
    width: '189px',
    height: '189px',
    left: '381px',
    top: '132px',
  },
  secondImage: {
    position: 'absolute',
    width: '189px',
    height: '189px',
    top: '64px',
    right: '381px',
  },

  ContentBox: {
    minHeight: '180px',
    backgroundColor: 'rgba(33, 35, 40, 1)',
  },

  titlebox: {
    fontFamily: 'Gilroy-Regular, sans-serif',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '30px',
    textTransform: 'capitalize',
    color: '#fff',
    padding: '25px',
  },

}));

export const GetStarted = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Grid item xs={12}>
        <div className={classes.auctionPageTitle}>
          Resources for getting started
        </div>
      </Grid>
      <Grid container style={{ position: 'relative' }}>
        <Grid item xs={4} className={classes.grid}>
          <Card className={classNames(classes.card)}>
            <CardActionArea href="https://fetch.ai/fetch-ais-colearn-paint/">
              <Paper elevation={0} className={classes.media}>
                <CardMedia
                    image={blogIcon}
                    className={classes.img}
                />
              </Paper>
              <CardContent className={classes.ContentBox}>
                <Typography variant="body2" color="textSecondary" component="p" className={classes.titlebox}>
                  How does colearn pAInt work?
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={4} className={classNames(classes.grid)}>
          <Card className={classNames(classes.card)}>
            <CardActionArea href="https://fetch.ai/fetch-ai-colearn-paint-faqs/">
              <Paper elevation={0} className={classes.media}>
                <CardMedia
                    image={faqIcon}
                    className={classes.img}
                />
              </Paper>
              <CardContent className={classes.ContentBox}>
                <Typography variant="body2" color="textSecondary" component="p" className={classes.titlebox}>
                  Colearn pAInt: FAQs
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={4} className={classes.grid}>
          <Card className={classNames(classes.card)}>
            <CardActionArea href="https://youtu.be/n3C-40-lX7g">
              <Paper elevation={0} className={classes.media}>
                <CardMedia
                    image={videoIcon}
                    className={classes.img}
                />
              </Paper>
              <CardContent className={classes.ContentBox}>
                <Typography variant="body2" color="textSecondary" component="p" className={classes.titlebox}>
                  Colearn pAInt: video walkthrough
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
